import Page from '../../classes/Page'
import each from 'lodash/each'

import { app } from '../../utils/store'

export default class SingleAccessory extends Page{
    constructor(){
        super({
            id : 'single_accessory',
            element: '[data-app-page]',
            elements: {},
            scroller: app.content
        })
    }

    create() {
        super.create()
    }
    
    addEventListeners() {
        
    }

    destroy(){ 
        super.destroy()
    }
}